import { render } from "./Slots.vue?vue&type=template&id=2b54622d"
import script from "./Slots.vue?vue&type=script&lang=js"
export * from "./Slots.vue?vue&type=script&lang=js"

import "./Slots.vue?vue&type=style&index=0&id=2b54622d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__